import React from 'react';

export default function Map() {
  return (
    <div className="text-center mt-5 mb-5 ">
      <iframe
        src="https://maps.google.com/maps?q=GOC%20Cafe%20KM%2016,%20QL27,%20ch%E1%BB%A3%20Trung%20Ho%C3%A0,%20C%C6%B0%20Kuin%20District,%20%C4%90%E1%BA%AFk%20L%E1%BA%AFk%20Province,%20Vietnam&t=&z=15&ie=UTF8&iwloc=&output=embed"
        class="border border-light rounded"
        style={{ width: '70%', height: '25rem', border: '0' }}
        frameborder="0"
        allowfullscreen=""
        aria-hidden="false"
        tabindex="0"
        title="trung hoa cafe"
      ></iframe>
    </div>
  );
}
//create a link here
//https://www.embedgooglemap.net/